<template>
    <div class="user-index">
        <div class="user-index-item clearfloat" v-for="(item, index) in strategyList" 
        :key="'user_'+index">
            <userChart class="float-left" v-if="chartArr" :chartData="chartArr[item.id_]"></userChart>
            <div class="user-index-detail float-left">
                <ul>
                    <li><span class="user-detail-name">{{item.names}}</span></li>
                    <li>
                        <span class="user-detail-tilte">总资产：</span><span>{{(item.capital).toFixed(2)}}</span>
                    </li>
                    <li>
                        <span class="user-detail-tilte">市值：</span><span>{{(item.equity).toFixed(2)}}</span>
                    </li>
                    <li>
                        <span class="user-detail-tilte">可用资金：</span><span>{{item.cash}}</span>
                    </li>
                    <li>
                        <span class="user-detail-tilte">初始资金：</span><span>{{item.initial_money}}</span>
                    </li>
                    <li>
                        <span class="user-detail-tilte">累计收益率：</span><span>{{item.accumulated_earnings}}%</span>
                    </li>
                    <li>
                        <router-link class="user_btn__style" @click.native="jumpToStatic(item.id, item.id_)"
                        :to="{path: '/user/static', query: {value: item.id+'**1'}}">数据统计</router-link>
                        <!-- <el-button class="user_btn__style" >
                        </el-button> -->
                    </li>
                </ul>
            </div>
            
        </div>
    </div>
</template>

<script>
import { mapState } from "vuex";
import userChart from "@/components/user/User-chart.vue";
import { stringify } from 'querystring';
import { get } from "@/api/index";

export default {
    components: {
        userChart
    },
    data: function () {
        return {
            socketObj: '',
            strategyList: [],
            lengthArr: 0,
            chartArr: {},
            indexChartLoad: false,
        }
    },
    mounted() {
        this.createSocket();
    },
    computed: {
        ...mapState([
            "token",
            "userSocket",
            "loadingFlag"
        ])
    },
    watch: {
        lengthArr: function () {
            if (this.lengthArr > 0) {
                console.log('length change', this.lengthArr);
                // this.indexChartLoad = true;
                this.getUserChart();
            }
        }
    },
    methods: {
        
        // websocket 创建
        createSocket() {
            this.indexChartLoad = true;
            var url = this.$socket_url_ln + "/web/user/socket?token="+this.token;
            // console.log(this.userSocket)
            if (this.userSocket && this.userSocket.skt) {

            } else {
                this.userSocket['skt'] = new WebSocket(url);
                console.log("WebSocket connect successful")
            }

            this.webSocketInit();
        },

        // websocket init
        webSocketInit() {
            this.userSocket.skt.onopen = this.socketOpen;
            this.userSocket.skt.onmessage = this.socketReceive;
            this.userSocket.skt.onclose = this.socketClose;
        },

        // socket 发送函数
        socketOpen() {},

        // socket 接收函数
        socketReceive(res) {
            // console.log(typeof res.data, res.data);
            var res_data = JSON.parse(res.data);
            if (res_data.code === 200) {
            }
            this.strategyList = res_data.strategy;
            this.lengthArr = this.strategyList.length;
            this.$store.commit('setUserChartData', res_data);
            this.$store.commit('setLoadingFlag', false);
        },

        // socket 关闭函数
        socketClose() {
            this.$store.commit('setLoadingFlag', false);
            console.warn("WebSocket closed!");
        },

        // 获取图表数据
        getUserChart() {
            var url = this.$url_LN_local + "/get/chart/data";
            var strategy_list = [];

            for (var i=0; i<this.strategyList.length; i++) {
                var strategy_id = this.strategyList[i].id;
                strategy_list.push(strategy_id);
            }

            var param = {"sign": JSON.stringify(strategy_list), "token": this.token, "target": 1};

            get(url, param).then(res => {
                if (res.code === 200) {
                    this.chartArr = res.data;
                    this.indexChartLoad = false;
                } else {
                    this.$notify.error({
                        message: res.info,
                        title: "提示",
                        offset: 200
                    })
                }
            })
        },

        // 统计页面跳转
        jumpToStatic(id, rid) {
            this.$store.commit('setUserStrategyId', rid);
            sessionStorage.setItem('sidd', rid);
            console.log('set_sid', rid);
           
        }
    } 
}
</script>

<style lang="scss" scoped>
.user-index {
    background-color: #252425;
    color: #a8a7a9;
    width: 80%;
    margin: 0 auto;
    padding: 20px 0;
    text-align: left;
    .user_btn__style {
        width: 90%;
        background-color: #333333;
        border-color: #333333;
        color: #a8a7a9;
        padding: 5px 10px;
        border-radius: 5px;
        text-align: center;
        display: block;
    }
    .user_btn__style:hover {
        background-color: #252425;
    }
    .user-index-detail {
        // margin-left: 10px;
        height: 250px;
        // position: relative;

        display: table;
        ul {
            display: table-cell;
            vertical-align: middle;
        }
        li {
            text-align: left;
            padding: 5px 10px;
            .user-detail-tilte {
                min-width: 70px;
                display: inline-block;
            }
        }
    }

    .user-index-item {
        margin-bottom: 20px;
        background-color: #2a2d2e;
        display: inline-block;
        margin: 10px;
        width: 472px;
        .user-detail-name {
            font-weight: 600;
            font-size: 16px;
            max-width: 145px;
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
            display: inline-block;
        }
    }
}
</style>

